/**
 * Automation domain constants — triggers, actions, operators, fields.
 * Le `label`/`desc` sono chiavi i18n: vanno passate a t() dal componente.
 */
import {
  Zap, Play, Clock, Bell, Star, Heart, UserX, Gift, RefreshCw, Crown, Sparkles,
  Tag as TagIcon, CheckCircle2, X, Send, MessageSquare, Mail, Activity, Users,
  Receipt, Calendar,
} from "lucide-react";

export const PRESET_ICONS = {
  clock: Clock, bell: Bell, star: Star, heart: Heart, "user-x": UserX,
  gift: Gift, refresh: RefreshCw, crown: Crown, sparkles: Sparkles, tag: TagIcon,
};

export const TRIGGERS = [
  { key: "appointment_created", label: "automations.triggers.appointment_created", icon: Calendar, filter: "appointment" },
  { key: "appointment_completed", label: "automations.triggers.appointment_completed", icon: CheckCircle2, filter: "appointment" },
  { key: "appointment_cancelled", label: "automations.triggers.appointment_cancelled", icon: X, filter: null },
  { key: "invoice_paid", label: "automations.triggers.invoice_paid", icon: Receipt, filter: "invoice" },
  { key: "client_created", label: "automations.triggers.client_created", icon: Users, filter: "client_source" },
  { key: "client_tag_added", label: "automations.triggers.client_tag_added", icon: TagIcon, filter: "tag" },
  { key: "client_birthday", label: "automations.triggers.client_birthday", icon: Gift, filter: null },
  { key: "client_inactive_days", label: "automations.triggers.client_inactive_days", icon: RefreshCw, filter: "inactive_days" },
  { key: "manual", label: "automations.triggers.manual", icon: Play, filter: null },
];
export const TRIGGER_MAP = Object.fromEntries(TRIGGERS.map((t) => [t.key, t]));

export const ACTIONS = [
  { key: "wait", label: "automations.actionLabels.wait", icon: Clock, desc: "automations.actionDescs.wait" },
  { key: "send_whatsapp", label: "automations.actionLabels.send_whatsapp", icon: Send, desc: "automations.actionDescs.send_whatsapp" },
  { key: "send_email", label: "automations.actionLabels.send_email", icon: Mail, desc: "automations.actionDescs.send_email" },
  { key: "add_tag", label: "automations.actionLabels.add_tag", icon: TagIcon, desc: "automations.actionDescs.add_tag" },
  { key: "add_note", label: "automations.actionLabels.add_note", icon: MessageSquare, desc: "automations.actionDescs.add_note" },
  { key: "log", label: "automations.actionLabels.log", icon: Activity, desc: "automations.actionDescs.log" },
];
export const ACTION_MAP = Object.fromEntries(ACTIONS.map((a) => [a.key, a]));

export const OPS = [
  { key: "eq", label: "automations.ops.eq" },
  { key: "neq", label: "automations.ops.neq" },
  { key: "gt", label: "automations.ops.gt" },
  { key: "gte", label: "automations.ops.gte" },
  { key: "lt", label: "automations.ops.lt" },
  { key: "lte", label: "automations.ops.lte" },
  { key: "contains", label: "automations.ops.contains" },
  { key: "in", label: "automations.ops.in" },
  { key: "exists", label: "automations.ops.exists" },
  { key: "not_exists", label: "automations.ops.not_exists" },
];

export const FIELDS = [
  { key: "client.name", label: "automations.fields.client_name" },
  { key: "client.email", label: "automations.fields.client_email" },
  { key: "client.phone", label: "automations.fields.client_phone" },
  { key: "client.source", label: "automations.fields.client_source" },
  { key: "client.tags", label: "automations.fields.client_tags" },
  { key: "client.birthday", label: "automations.fields.client_birthday" },
  { key: "client.consents.marketing_email", label: "automations.fields.client_consents_marketing_email" },
  { key: "client.consents.marketing_sms", label: "automations.fields.client_consents_marketing_sms" },
  { key: "appointment.service_id", label: "automations.fields.appointment_service_id" },
  { key: "appointment.status", label: "automations.fields.appointment_status" },
  { key: "invoice.total", label: "automations.fields.invoice_total" },
  { key: "invoice.payment_method", label: "automations.fields.invoice_payment_method" },
  { key: "added_tag", label: "automations.fields.added_tag" },
];

export const STATUS_STYLES = {
  pending: "bg-slate-100 text-slate-700",
  running: "bg-cyan-100 text-cyan-700",
  done: "bg-emerald-100 text-emerald-700",
  dead: "bg-rose-100 text-rose-700",
};

export { Zap };
